import { classSet, Loader } from '@platform/ui-library';
import styles from './LoadingSpinner.module.scss';

export type LoadingSpinnerProps = {
  message?: string | JSX.Element;
  hideSpinner?: boolean;
  className?: string;
};

export const LoadingSpinner = ({
  className,
  hideSpinner,
  message = 'Downloading Content...'
}: LoadingSpinnerProps) => {
  return (
    <div className={classSet([styles.loadingSpinner, className])}>
      <Loader loading={!hideSpinner} variant="micro" />
      {message}
    </div>
  );
};
